import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@/components/atoms/Button';
import Heading from '@/components/atoms/Heading';
import Icon from '@/components/atoms/Icon';
import Media from '@/components/atoms/Media';
import updateDataLayer from '@/utils/gtml';
import { twMerge } from 'tailwind-merge';
const Content = ({ title, text, link, image }) => (_jsxs("div", { className: "flex flex-col items-start gap-1", children: [image && (_jsx(Media, { media: image, imageSizes: { base: { ratio: 16 / 9 }, xl: { vw: 4 / 10 } }, containerClassName: "w-full", mediaClassName: "w-full aspect-video overflow-hidden", imageClassName: twMerge('w-full h-full', link && 'group-hover:scale-105 transition-transform duration-1000') })), _jsx(Heading, { as: "h2", variant: "ex-sm", children: title }), text && _jsx("p", { className: "type-body-md line-clamp-3 text-text-body", children: text }), link && (_jsx(Button, { mode: "non-interactive", variant: link.linkDisplay, icon: link.linkIcon, width: "auto", children: (props) => (_jsxs("span", { className: props.className, children: [link.text, _jsx(Icon, { variant: props.icon, className: "h-1 w-1" })] })) }))] }));
const HeaderNavCard = (props) => {
    if (props.link) {
        return (_jsx("a", { href: props.link.url, target: props.link.target, className: "group", onClick: () => updateDataLayer({
                event: 'ctaClick',
                cta_type: props.link?.linkDisplay,
                click_text: props.link?.text,
                click_url: props.link?.url,
            }), children: _jsx(Content, { ...props }) }));
    }
    return _jsx(Content, { ...props });
};
export default HeaderNavCard;
